import * as React from "react";
import {Display} from "../../../components/Display";
import {ReadAndWriteContext} from "../../../providers/ReadAndWriteProvider";
import {Loader} from "../../../components/Utils/loader/Loader";
import {TopBar} from "../../widgets/TopBar";
import {renderPage} from "./utils";
import {DefaultErrorBoundaryFallback} from "../../../ErrorBoundary/DefaultErrorBoundaryFallback";
import {useTheme} from "@vebox/etui-system";
import {Theme} from "@vebox/etui-themes";

export enum PAGES {
    SETTINGS = "Settings",
    INFO = "Info",
    UPDATING = "Updating",
    EDITING = "Editing",
}

export const MainContentPage: React.FC = () => {
    const {
        deviceSlaveSettings,
        IsRWSupportedCheck,
        availableRegisters,
        currentPage,
        currentTab,
        hasPermissionsToSeeSettings,
        hasPermissionsToEditSettings,
        AppTranslations,
        changePage
    } = React.useContext(
        ReadAndWriteContext);

    const [isLoading, setIsLoading] = React.useState<boolean>(true);
    const [dataError, setDataError] = React.useState<Error>();
    const theme = useTheme() as Theme;


    React.useEffect(() => {
        setIsLoading(IsRWSupportedCheck?.isLoading || deviceSlaveSettings?.isLoading || availableRegisters?.isLoading);
        setDataError(deviceSlaveSettings?.error || availableRegisters?.error);
    }, [deviceSlaveSettings, IsRWSupportedCheck, availableRegisters]);

    React.useEffect(() => {
        changePage(PAGES.SETTINGS);
    }, [deviceSlaveSettings.isValidating]);

    React.useEffect(() => {
        setIsLoading(true);
    }, []);

    return (
        <>
            <Display isVisible={isLoading}>
                <div className={"loader-container"}>
                    <Loader relativelyCentered={true}/>
                </div>
            </Display>
            <Display isVisible={!isLoading && !dataError}>
                <TopBar/>
                {renderPage(currentPage, currentTab, hasPermissionsToSeeSettings, hasPermissionsToEditSettings,
                    IsRWSupportedCheck?.data?.supported)}
            </Display>
            <Display isVisible={!isLoading && dataError}>
                <div className={"error-container"}>
                    <DefaultErrorBoundaryFallback
                        errorMessage={AppTranslations.errorMessages.somethingWentWrong}
                        style={{backgroundColor: theme.palette.common.white}}
                    />)
                </div>
            </Display>
        </>
    );
};

